import { ProjectDetailsComponent } from "./project-details.component";
import { RouterModule, Routes } from "@angular/router";
import { ProjectStepModule } from "../projectstep/projectstep.module";

const routes: Routes = [
    { path: ':Id', component: ProjectDetailsComponent },    
    { path: 'new', component: ProjectDetailsComponent },    
    { path: ':Id/projectstep', loadChildren: () => ProjectStepModule },    
    { path: ':Id/orderstep', loadChildren: () => ProjectStepModule },    
    { path: ':Id/servicestep', loadChildren: () => ProjectStepModule },    
    { path: ':Id/consultationstep', loadChildren: () => ProjectStepModule }
];

export const ProjectDetailsRouting = RouterModule.forChild(routes);